// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-history-container {
  overflow-y: auto;
  padding: 0px 20px 10px 20px;
}

.chat-history-container::-webkit-scrollbar {
  width: 6px;
}

.chat-history-container::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background-color: #a6a5a5;
}

.chat-history-container::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.chat-history-container::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
}

.chat-history-date {
  /* margin-top: 20px !important; */
  margin-bottom: 10px;
  color: black;
  font-size: 12px;
  font-weight: 300;
  background-color: #F0F4F8;

  /*opacity: 0;
    animation: fadeIn 0.7s ease-out forwards;*/
}

.chat-history-date:nth-child(1) {
  margin-top: 0 !important;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.chat-history-body {
  position: relative;
  margin-top: 5px;
  background-color: #ffffff00;
  display: flex;
  flex-direction: row;

  transition: background-color 0.3s ease;

  /* transform: translateX(-50px);
  animation: Slide 0.7s ease-out forwards; */

  font-size: 12px;
  font-weight: 600;
}

.chat-history-body-link {
  color: #333;
  width: 100%;

  cursor: pointer;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-decoration: none;
  font-weight: bold;
}
.chat-history-body-link:hover {
  /* color: #2895eb; */
  text-decoration: underline;
}
@keyframes Slide {
  to {
    transform: translateY(0);
  }
}

.chat-history-body:hover .chat-history-body-link {
  color: black;
  text-decoration: underline;
}

.chat-history-body.active .chat-history-body-link {
  color: black;
  text-decoration: underline;
}

.chat-history-body.disabled .chat-history-body-link {
  background-color: transparent;
}

.chat-row-wrapper {
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  min-height: 30px;
  border-bottom: 1px solid #f0f0f0;
  margin: 0; /* Remove any margin */
}

.chat-row-date {
  background: #f5f5f5;
  font-size: 0.95em;
  color: #888;
  font-weight: 600;
  justify-content: flex-start;
  border-bottom: 1px solid #e0e0e0;
}

.chat-history-date,
.chat-history-body {
  margin: 0;
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/chat/History.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;;EAEzB;8CAC4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;;EAEnB,sCAAsC;;EAEtC;4CAC0C;;EAE1C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;;EAEX,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,SAAS,EAAE,sBAAsB;AACnC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ","sourcesContent":[".chat-history-container {\n  overflow-y: auto;\n  padding: 0px 20px 10px 20px;\n}\n\n.chat-history-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.chat-history-container::-webkit-scrollbar-thumb {\n  border-radius: 20px;\n  background-color: #a6a5a5;\n}\n\n.chat-history-container::-webkit-scrollbar-track {\n  background-color: #f1f1f1;\n}\n\n.chat-history-container::-webkit-scrollbar-corner {\n  background-color: #f1f1f1;\n}\n\n.chat-history-date {\n  /* margin-top: 20px !important; */\n  margin-bottom: 10px;\n  color: black;\n  font-size: 12px;\n  font-weight: 300;\n  background-color: #F0F4F8;\n\n  /*opacity: 0;\n    animation: fadeIn 0.7s ease-out forwards;*/\n}\n\n.chat-history-date:nth-child(1) {\n  margin-top: 0 !important;\n}\n\n@keyframes fadeIn {\n  to {\n    opacity: 1;\n  }\n}\n\n.chat-history-body {\n  position: relative;\n  margin-top: 5px;\n  background-color: #ffffff00;\n  display: flex;\n  flex-direction: row;\n\n  transition: background-color 0.3s ease;\n\n  /* transform: translateX(-50px);\n  animation: Slide 0.7s ease-out forwards; */\n\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.chat-history-body-link {\n  color: #333;\n  width: 100%;\n\n  cursor: pointer;\n  display: block;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  text-decoration: none;\n  font-weight: bold;\n}\n.chat-history-body-link:hover {\n  /* color: #2895eb; */\n  text-decoration: underline;\n}\n@keyframes Slide {\n  to {\n    transform: translateY(0);\n  }\n}\n\n.chat-history-body:hover .chat-history-body-link {\n  color: black;\n  text-decoration: underline;\n}\n\n.chat-history-body.active .chat-history-body-link {\n  color: black;\n  text-decoration: underline;\n}\n\n.chat-history-body.disabled .chat-history-body-link {\n  background-color: transparent;\n}\n\n.chat-row-wrapper {\n  display: flex;\n  align-items: center;\n  padding: 0 16px;\n  box-sizing: border-box;\n  width: 100%;\n  background: #fff;\n  min-height: 30px;\n  border-bottom: 1px solid #f0f0f0;\n  margin: 0; /* Remove any margin */\n}\n\n.chat-row-date {\n  background: #f5f5f5;\n  font-size: 0.95em;\n  color: #888;\n  font-weight: 600;\n  justify-content: flex-start;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.chat-history-date,\n.chat-history-body {\n  margin: 0;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
